import React from "react";

/** Result of a button click or a load error. */
export function Banner({ message, onClose }) {
  if (!message) return null;
  return (
    <div className={`ams-banner${message.error ? " ams-banner--err" : ""}`} role="status">
      <span>{message.text}</span>
      <button type="button" className="ams-banner-close" onClick={onClose} aria-label="Dismiss">×</button>
    </div>
  );
}

/** What needs the dev team, with shortcuts to the filtered tabs. */
export function ProblemAlert({ summary, onShow }) {
  if (!summary) return null;
  const parts = [];
  if (summary.stores_red) parts.push(`${summary.stores_red} ${summary.stores_red === 1 ? "store needs" : "stores need"} dev work`);
  if (summary.subs_red) parts.push(`${summary.subs_red} ${summary.subs_red === 1 ? "subscription has" : "subscriptions have"} a problem`);
  if (summary.dw_level === "red") parts.push("warehouse sync is stuck");
  if (summary.sqs_errors) parts.push(`${summary.sqs_errors} SQS ${summary.sqs_errors === 1 ? "queue cannot" : "queues cannot"} be read`);
  if (!parts.length) return null;
  return (
    <div className="ams-banner ams-banner--alert" role="status">
      <span>
        <strong>{parts.join(", ")}.</strong>
        {summary.stores_red > 0 && (
          <button type="button" className="ams-link" onClick={() => onShow("stores")}>Show stores</button>
        )}
        {summary.subs_red > 0 && (
          <button type="button" className="ams-link" onClick={() => onShow("subscriptions")}>Show subscriptions</button>
        )}
      </span>
    </div>
  );
}

function Badge({ counts }) {
  if (!counts) return null;
  if (counts.red) return <span className="ams-badge" title={`${counts.red} need dev work`}>{counts.red}</span>;
  if (counts.amber) return <span className="ams-badge ams-badge--amber" title={`${counts.amber} recovering`}>{counts.amber}</span>;
  return null;
}

export const TABS = ["data", "stores", "subscriptions"];

export function Tabs({ tab, onChange, storeCounts, subCounts }) {
  const items = [
    ["data", "Data", null],
    ["stores", "Stores", storeCounts],
    ["subscriptions", "Subscriptions", subCounts],
  ];
  const onKey = (e, i) => {
    if (e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
    const next = TABS[(i + (e.key === "ArrowRight" ? 1 : TABS.length - 1)) % TABS.length];
    onChange(next);
    const el = document.getElementById(`ams-tab-${next}`);
    if (el) el.focus();
    e.preventDefault();
  };
  return (
    <div className="ams-tabs" role="tablist" aria-label="Marketing Stream sections">
      {items.map(([key, label, counts], i) => (
        <button key={key} id={`ams-tab-${key}`} type="button" role="tab" className="ams-tab"
                aria-selected={tab === key} aria-controls={`ams-panel-${key}`} tabIndex={tab === key ? 0 : -1}
                onClick={() => onChange(key)} onKeyDown={(e) => onKey(e, i)}>
          {label} <Badge counts={counts} />
        </button>
      ))}
    </div>
  );
}
